(function(){
    'use strict';
    angular.module('elogbooks.user.finance.credit-notes', []);
})();
